var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"back",attrs:{"icon":"","large":""}},[_c('router-link',{attrs:{"to":"/tienda"}},[_c('v-icon',{staticClass:"icon atras",on:{"click":function($event){return _vm.reset()}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }